import { render, staticRenderFns } from "./ObiIcon.vue?vue&type=template&id=ce35e79e&scoped=true&"
import script from "./ObiIcon.vue?vue&type=script&lang=js&"
export * from "./ObiIcon.vue?vue&type=script&lang=js&"
import style0 from "./ObiIcon.vue?vue&type=style&index=0&id=ce35e79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce35e79e",
  null
  
)

export default component.exports